export default __webpack_public_path__ + "static/2-de25b2d9afbbaac72a4ccd8312e70ef1.jpeg";